export enum ExperimentRequestTypes {
  GetAllExperimentsOptedOutRequest = 'experiment.getAllExperimentsOptedOut.request',
  GetAllExperimentsOptedOutSuccess = 'experiment.getAllExperimentsOptedOut.success',
  GetAllExperimentsOptedOutFailure = 'experiment.getAllExperimentsOptedOut.failure',
  SetExperimentOptedOutRequest = 'experiment.setExperimentOptedOut.request',
  SetExperimentOptedOutSuccess = 'experiment.setExperimentOptedOut.success',
  SetExperimentOptedOutFailure = 'experiment.setExperimentOptedOut.failure',
}
